import React, { useState, useEffect } from 'react';
import { BsSquare, 
         BsCheckSquare }    from "react-icons/bs";

function CheckBoxDisplay( { checkState, index, clickHandler } ) {
    const [state, setState] = useState('');

    useEffect(() => {
        if (typeof checkState !== 'undefined') {
            setState(checkState);
        }
    }, [checkState]); // Runs when initialData changes
    
    return(<> 
             { state && state === 1 ? (<BsCheckSquare onClick={() => clickHandler(index)} />) : (<BsSquare onClick={() => clickHandler(index)}/>) }
           </>);
}

export default CheckBoxDisplay;
